import React from 'react';
import {connect} from 'react-redux';
import {fallbackToArray} from '~/misc/search';
import get from 'lodash/get';
import cs from 'classnames';

import {idToFull} from '../../misc/equipment';
import {requestRecent} from '~/modules/recentSearches/actions';
import mapDispatch from '~/misc/mapDispatch';

import css from './index.css';
import sharedCSS from '../shared.css';

const renderLocation = (name, deadhead) => `${name}${deadhead ? ` (+${parseInt(deadhead)} mi)` : ''}`;

const handleClick = (props, e) => requestRecent(e.currentTarget.getAttribute('data-num'));

const renderItem = ({from_name: fromName, dho, to_name: toName, dhd, ...item}, index, click) => (
  <tr
    key={item.id}
    className={cs(css.row, 'qa-recent', `qa-recent-row-${index}`)}
    data-num={index}
    onClick={click}
  >
    <td className='qa-recent-origin'>{fromName ? renderLocation(fromName, dho) : 'Anywhere'}</td>
    <td className={css.arrowCell}/>
    <td className='qa-recent-destination'>{toName ? renderLocation(toName, dhd) : 'Anywhere'}</td>
    <td className='qa-recent-equipment'>{
      get(item, 'equipment.length')
        ? fallbackToArray(item.equipment).map(eq => idToFull[eq]).join(', ')
        : 'Any'
    }</td>
  </tr>
);

const RecentSearches = ({items, dashboard, click}) => {
  if (!items.length) {
    if (dashboard) {
      return null;
    }

    return (
      <div className={css.placeholder}>
        <div>
          <div className={sharedCSS.h1}>
            Oops! You do not have any Recent Searches
          </div>
          <div>Please perform a load search and try again</div>
        </div>
      </div>
    );
  }
  return (
    <div>
      {dashboard ? <div className={cs(sharedCSS.h1, css.header)}>Recent searches</div> : null}
      <table className={cs(css.table, 'qa-recent-table')}>
        <thead>
          <tr>
            <th colSpan='2'>Origin</th>
            <th>Destination</th>
            <th>Truck</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item, i) => renderItem(item, i, click))}
        </tbody>
      </table>
    </div>
  );
};

export default connect(
  state => state.recentSearches,
  mapDispatch({
    click: handleClick,
  })
)(RecentSearches);



// WEBPACK FOOTER //
// ./src/components/RecentSearches/index.js